var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#small-glass_svg__clip0)",
    stroke: "#91C300",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.172.857a.56.56 0 01.399.184.652.652 0 01.114.458l-3.302 24.828c-.029.275-.257.488-.513.488H6.662c-.256 0-.484-.213-.513-.488L2.847 1.499a.615.615 0 01.114-.458.544.544 0 01.399-.184h19.812z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23 6.3h19.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "small-glass_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.23)",
    d: "M0 0h26.154v30H0z"
  })))));
}

export default SvgSmallGlass;